export const API_BASE = process.env.REACT_APP_API_URL || "";

export async function api(path, options = {}) {
  const token = localStorage.getItem("token");
  const isFormData = options.body instanceof FormData;
  const headers = {
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    ...options.headers,
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  if (res.status === 401) {
    localStorage.clear();
    window.location.href = "/";
    throw new Error("Session expired");
  }

  return res;
}

export async function apiJson(path, options = {}) {
  const res = await api(path, options);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Request failed");
  return data;
}

export function apiBlob(path, options = {}) {
  return api(path, options).then((res) => {
    if (!res.ok) throw new Error("Download failed");
    return res.blob();
  });
}
